// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardActionArea {
  border-radius: 0.5rem;
}
.cardActionArea .priorityBox {
  display: flex;
  border: 1px solid #DCDFE1;
  padding: 0.3rem 0.4rem;
  border-radius: 0.5rem;
  cursor: pointer;
  gap: 0.5rem;
}
.cardActionArea .priorityBox .badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  flex: 0 0 1;
}
.cardActionArea .priorityBox .inlineBox {
  max-width: 80%;
  text-align: center;
  border-radius: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ResutTest/JobGroups/PriorityBox/box.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;AACI;EACI,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AACR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AACZ;AAEQ;EACI,cAAA;EACA,kBAAA;EACA,qBAAA;AAAZ","sourcesContent":[".cardActionArea {\n    border-radius: 0.5rem;\n\n    .priorityBox {\n        display: flex;\n        border: 1px solid #DCDFE1;\n        padding: 0.3rem 0.4rem;\n        border-radius: 0.5rem;\n        cursor: pointer;\n        gap: 0.5rem;\n\n        .badge {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 30px;\n            height: 30px;\n            border-radius: 100%;\n            flex: 0 0 1;\n        }\n\n        .inlineBox {\n            max-width: 80%;\n            text-align: center;\n            border-radius: 0.5rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
